export default function initData(translate) {
	return (dispatch) => {
		dispatch({
			type: 'CHANGE_LANGUAGE',
			payload: translate,
		});
	};
}